import { CheckoutOpenOptions } from '@paddle/paddle-js';
import { invokeEvent } from 'shared-base';
import { discountMapping, paddingMapping, paddleInstance, userEmail } from './globals';

export const openCheckout = (productId: ProductId) => {
  const priceId = paddingMapping[productId];

  try {
    if (!paddleInstance) {
      throw new Error('Paddle instance not initialized');
    }

    const discountId = (discountMapping[productId] ?? '').trim();

    const payload: CheckoutOpenOptions = {
      items: [
        {
          priceId: priceId,
          quantity: 1,
        },
      ],
    };

    const partneroQueryParam = 'aff';
    const partneroCookieName = 'partnero_partner';

    function getCookie(name: string) {
      const cookieArr = document.cookie.split(';').map((cookie) => cookie.trim());
      for (const cookie of cookieArr) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (name === cookieName) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    }

    const customerKey =
      new URLSearchParams(window.location.search).get(partneroQueryParam) ||
      getCookie(partneroCookieName);

    if (customerKey) {
      payload.customData = payload.customData || {};
      payload.customData.customer_key = customerKey;
    }

    if (userEmail) {
      payload.customer = {
        email: userEmail,
      };
    }

    // if discount exists
    if (discountId) {
      payload.discountId = discountId;
    }

    console.log('Paddle Checkout Payload: ', payload);

    paddleInstance.Checkout.open(payload);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};

export const closeCheckoutOverlay = () => {
  try {
    if (!paddleInstance) {
      throw new Error('Paddle instance not initialized');
    }

    paddleInstance.Checkout.close();
  } catch (err) {
    invokeEvent('sentry', { err });
  }
};
